// ── shared, reusable pure helpers for the reconciliation-v2 activity log ─────

const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

/**
 * Formats a nullable numeric/string amount as a USD currency string.
 * Returns null for empty/non-finite input so callers can omit the field.
 */
export const formatAmount = (amount: number | string | null): string | null => {
  if (amount == null || amount === '') return null
  const n = typeof amount === 'number' ? amount : Number(amount)
  return Number.isFinite(n) ? usd.format(n) : null
}
